import { Container, Alert, Row, Col, Card, ListGroup } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import { useAuth } from '../context/AuthContext'
export default function Settings() {
  const { user } = useAuth()
  const isMasterAdmin = user?.businessLevel === 'MasterAdmin'
  return (
    <Container>
      <h1 className="mb-4">Settings</h1>
      <Alert variant="light">Configuration overview for rule packs, prompts, concurrency, audit export, and term references.</Alert>

      <Card className="mb-4">
        <Card.Body>
          <Card.Title>Brand keyword whitelist</Card.Title>
          <Card.Text className="mb-0">
            Manage Kingspan-related brand names used for distributor website search and core product compliance checks
            in <Link to="/pim?tab=brand-whitelist">MIM Setup → Brand whitelist</Link>.
          </Card.Text>
        </Card.Body>
      </Card>

      {isMasterAdmin && (
        <Card className="mb-4 border-danger">
          <Card.Body>
            <Card.Title className="text-danger">Danger zone</Card.Title>
            <Card.Text className="mb-0">
              Clear test/demo data to run a clean end-to-end test pass, without touching login accounts or
              organisation setup. See <Link to="/admin/data-reset">Reset application data</Link>.
            </Card.Text>
          </Card.Body>
        </Card>
      )}

      <Row xs={1} md={2} className="g-3">
        <Col>
          <Card>
            <Card.Body>
              <Card.Title>Rule Packs</Card.Title>
              <Card.Text>Manage versioned rule packs and approval states.</Card.Text>
              <ListGroup variant="flush">
                <ListGroup.Item>Upload or draft new rule packs</ListGroup.Item>
                <ListGroup.Item>Approve and retire versions</ListGroup.Item>
                <ListGroup.Item>Assign packs to tenants or markets</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card>
            <Card.Body>
              <Card.Title>Prompt Packs</Card.Title>
              <Card.Text>Versioned prompts for AI-assisted extraction.</Card.Text>
              <ListGroup variant="flush">
                <ListGroup.Item>Track prompt pack versions</ListGroup.Item>
                <ListGroup.Item>Bind prompts to rule packs</ListGroup.Item>
                <ListGroup.Item>Capture approval and change history</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card>
            <Card.Body>
              <Card.Title>Concurrency & Scheduling</Card.Title>
              <Card.Text>Control job throughput and rate limits.</Card.Text>
              <ListGroup variant="flush">
                <ListGroup.Item>Global concurrency cap</ListGroup.Item>
                <ListGroup.Item>Per-domain rate limits</ListGroup.Item>
                <ListGroup.Item>Retry and backoff policy</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>

        <Col>
          <Card>
            <Card.Body>
              <Card.Title>Audit &amp; Export</Card.Title>
              <Card.Text>Evidence retention and export controls. See the Audit page for interactive log review.</Card.Text>
              <ListGroup variant="flush">
                <ListGroup.Item>Retention policy (7+ years)</ListGroup.Item>
                <ListGroup.Item>Evidence bundle download</ListGroup.Item>
              </ListGroup>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  )
}
